<template>

    <v-page-widget title="Traits" :can-expand="!this.query" actionTitle="Edit" :actionFunc="editTraits">
        <template #body>
            <v-searchbar class="mb-15" size="sm" :mag="false" :model="query" @input="query = $event" />
            <v-notice v-if="!filteredTraits.length" size="sm" message="No Traits Found" />
            <v-page-widget-prop v-for="trait in filteredTraits" :key="trait.field"
                :label="trait.name"
                :value="customer | valueForTrait(trait)">
            </v-page-widget-prop>
        </template>
    </v-page-widget>

</template>

<script>

export default {

    props: {
        customer: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            query: '',
        }
    },

    computed: {

        traits() {
            return this.$store.getters.project.traits.filter(trait => {
                if (trait.visibility.profile) {
                    return trait;
                }
            });
        },

        filteredTraits() {
            return this.traits.filter(t => {
                return !this.query || t.name.toLowerCase().includes(this.query.toLowerCase());
            });
        },

    },

    methods: {

        editTraits() {
            this.$router.push({ name: 'traits' });
        },

    },

}

</script>
